
import React from 'react';
import { Typography, Button, Box, Grid, Link } from '@mui/material';
import ButtonLoading from '../../../../components/ButtonLoading';
import { VariablesT } from '../../../../types/Company';
import { JobT, RevenueLineItemT } from '../../../../types/Job'
import { TransactionT } from '../../../../types/TransactionT';
import { revenueExistInTransactions } from '../JobUtils';
import { LineItemPayment } from './LineItemPayment';
import { AxiosInstance } from '../../../../utils/RequestMethods';
import config from '../../../../constants/config';
import _ from 'lodash';
import WithSkeleton from '../../../../components/WithSkeleton';
import { parseFloatTotal } from '../../../../utils/utilsT'
import { Spinner } from 'react-bootstrap';
export type IPaymentsReceiptProps = {
    job: JobT
    companyVariables: VariablesT
    items?: Array<RevenueLineItemT>
    transactions: Array<TransactionT>
}

const PaymentsReceipt: React.FC<IPaymentsReceiptProps> = (props) => {
    const [requestManager, setRequestManager] = React.useState(null);
    const [isReady, setIsReady] = React.useState(false);
    React.useEffect(() => {
        getRequestManager()
    }, []);

    const getRequestManager = async (): Promise<any> => {
        return await AxiosInstance.get(`${config.url.jobs}/${props.job.id}/request-manager`).then((res) => {
            if (res && res.data && _.has(res, "data.requestManager")) {
                setRequestManager(res.data.requestManager)
            }
            setIsReady(true)
        }).catch((error) => {
            setIsReady(true)
            throw error
        })
    }


    const fetchRequestManager = async (): Promise<string> => {
        return await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/request-manager`).then((res) => {
            if (res && res.data && _.has(res, "data.requestManager")) {
                setRequestManager(res.data.requestManager)
                return "Request sent to the manager."
            }
        })

    }


    /**
     *
     */
    const getTotal = React.useCallback(() => {
        let totalAmount = props.items.reduce((amount, item, index) => {
            return Number(amount) + Number(item.total)
        }, 0)

        return totalAmount
    }, [props.items])

    return (
        <div>
            <Typography variant="h6">Receipt</Typography>
            {props.items.map((item, index) => {
                const transaction = revenueExistInTransactions(item, props.transactions)
                return (
                    <LineItemPayment
                        key={index}
                        job={props.job}
                        isPaid={true}
                        index={index}
                        transaction={transaction ? transaction : null}
                        companyVariables={props.companyVariables}
                        item={item}
                    />
                )
            })}


            <Grid container spacing={2}>
                <Grid item xs={9}>
                </Grid>
                <Grid item xs>
                    <Box display="flex" flexDirection="row">

                        <Typography fontWeight="bold">Total<Typography>${parseFloatTotal(getTotal())} </Typography></Typography>
                    </Box>
                </Grid>
            </Grid>

            <WithSkeleton loading={!isReady} propsSkeleton={{ height: 50, width: "100%" }} >


                <Box display="flex" alignItems="center" justifyContent="flex-start" >
                    <Typography>Does something not look correct? </Typography>


                    {!requestManager ? <ButtonLoading
                        disabled={requestManager ? true : false}
                        bootstrap={false}
                        customButton={Button}
                        className="ml-1"
                        processingComponent={(<div style={{}}>
                            <Typography><Spinner animation="border" size="sm" /> Contact Manager ... </Typography>
                        </div>)}
                        customButtonProps={{
                            // fullWidth: true,
                            variant: "text",
                            // color: "success"
                        }}

                        onClickFetching={async (): Promise<string> => {
                            return await fetchRequestManager()
                        }}>
                        <Typography fontWeight={"bold"} >Contact Manager</Typography>
                    </ButtonLoading>
                        : <strong >&nbsp;Manager requested.</strong>
                    }
                </Box>
            </WithSkeleton>
        </div>
    );
}

export { PaymentsReceipt }
